import React, { useState } from "react";
//   {
//     question: "What documents do I need to rent a car?",
//     answer: "You will typically need a valid driver's license, a credit card in your name, and an additional proof of identity (such as a passport if you are traveling internationally).",
//   },
//   {
//     question: "Can I modify or cancel my booking?",
//     answer: "Yes, you can modify or cancel most bookings. Free cancellations are generally available up to 48 hours before your scheduled pick-up time.",
//   },
//   {
//     question: "Is insurance included?",
//     answer: "Basic third-party liability insurance is usually included, but optional comprehensive damage waivers or supplementary coverage can be added during checkout.",
//   },
//   {
//     question: "Do you offer airport pickup?",
//     answer: "Yes, we provide airport terminal counters or complimentary shuttle services to our off-site fleet stations at most major locations.",
//   },
//   {
//     question: "Can I book without a credit card?",
//     answer: "A valid credit card is standard for holding a security deposit, though select branches accept debit cards subject to additional background and insurance criteria.",
//   },
//   {
//     question: "Are there mileage limits?",
//     answer: "Most of our standard bookings include unlimited mileage, though specific specialty vehicles or local geographic boundaries may vary.",
//   },
// ];

const faqData = [
  {
    question: "What is RentGurus and how does it work?",
    answer:
      "RentGurus is an online platform that lets you search, compare, and book rental vehicles from established rental suppliers worldwide.\n\nWe act as an intermediary. We arrange and confirm your reservation, while the vehicle is provided directly by the supplier you choose.\n\nAt the rental desk, you sign the agreement directly with the supplier and collect your vehicle.",
  },
  {
    question: "How do I search and book a car on RentGurus?",
    answer:
      "Enter your pick-up location, dates, and times on our website.\n\nBrowse available vehicles, review the rental conditions for your chosen vehicle, and complete your booking online.\n\nYou will receive a confirmation email immediately once your booking is confirmed.",
  },
  {
    question:
      'What does "partially prepaid" mean? What do I pay now vs. at the desk?',
    answer:
      "This is a two-step payment process. You pay a small upfront amount at the time of booking to secure your reservation. When you arrive at the rental desk to collect the vehicle, you pay the remaining rental balance, any optional extras, local fees, and the security deposit directly to the supplier.",
  },
  {
    question: "How do I cancel my booking?",
    answer:
      "You can cancel your booking through the Manage Booking section on our website, or via the link in your confirmation email.\n\nFor further assistance, contact our support team at support@rentgurus.com.",
  },
  {
    question: "Can I add an additional driver? Is there a fee?",
    answer:
      "Whether additional drivers are permitted depends on the supplier.\n\nWhere permitted, all additional drivers must meet the same age and licence requirements as the main driver and must be present at pick-up.\n\nAn additional driver fee may apply per day, payable at the rental desk.\n\nSome suppliers do not permit additional drivers at all. Check the rental conditions at checkout.",
  },
  {
    question: "Where do I pick up the car at the airport?",
    answer:
      "The supplier name and pick-up location details are included in your confirmation email and rental voucher.\n\nAt most airports, rental desks are located in the arrivals terminal or a dedicated car rental centre. Follow the airport signage for 'Car Rental'.\n\nIf you are unable to locate the desk, contact the supplier directly using the contact details on your voucher.",
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-2 py-10 md:py-16 bg-surface font-body selection:bg-primary/10">
      <div className="flex flex-col lg:flex-row justify-between gap-10 lg:gap-14">
        {/* Left Side Content Column */}
        <div className="w-full lg:w-[32%] flex-shrink-0">
          <h2 className="text-[24px] md:text-[32px] font-bold tracking-tight text-[#071c2c] leading-[1.2] mb-3">
            Frequently asked
            <br />
            questions
          </h2>
          <p className="text-[15px] text-text-muted font-normal leading-[1.5]">
            Everything you need to know before you book. <br />
            Can't find the answer? Our team is one click away.
          </p>
        </div>

        {/* Right Side Accordion Grid List Column */}
        <div className="w-full lg:w-[62%]">
          <div className="flex flex-col">
            {faqData.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={index} className="border-b border-surface-border">
                  <button
                    onClick={() => toggleAccordion(index)}
                    className="w-full flex justify-between items-center py-4 text-left group transition-colors duration-150"
                  >
                    <span className="text-[15px] font-semibold text-text tracking-wide pr-4 font-heading">
                      {faq.question}
                    </span>
                    {/* Minimalist Arrow Down Chevron matching screenshot scale */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`h-4 w-4 text-text-light transition-transform duration-200 flex-shrink-0 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={1.5}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>

                  {/* Smooth Collapsible Answer Section */}
                  <div
                    className={`overflow-hidden transition-all duration-300 ease-in-out ${
                      isOpen ? "max-h-40 pb-4 opacity-100" : "max-h-0 opacity-0"
                    }`}
                  >
                    <p className="text-[14px] text-text-muted font-normal leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Bottom Green Auxiliary Link Anchor */}
          <div className="mt-6">
            <a
              href="/faqs"
              className="text-primary hover:text-primary/80 font-medium flex items-center gap-1.5 text-[14px] tracking-wide transition-colors duration-200 font-heading"
            >
              See more questions
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 translate-y-[0.5px]"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
